import { createAuth0Client, Auth0Client } from "@auth0/auth0-spa-js";
import { auth0Domain, auth0ClientID, auth0Audience } from "@/extensions/extra";

let auth0Client: Auth0Client | null = null;

export const getAuth0RedirectUri = (): string => {
  const redirectUriPath = process.env.VUE_APP_REDIRECT_URI;

  if (!redirectUriPath) {
    throw new Error("VUE_APP_REDIRECT_URI is not configured.");
  }

  return globalThis.location.origin + redirectUriPath;
};

export const initAuth0 = async (): Promise<Auth0Client> => {
  if (auth0Client) {
    return auth0Client;
  }

  auth0Client = await createAuth0Client({
    domain: auth0Domain,
    clientId: auth0ClientID,
    authorizationParams: {
      redirect_uri: getAuth0RedirectUri(),
      audience: auth0Audience,
      scope: "openid profile email",
    },
    cacheLocation: "localstorage", // SPA’ler için önerilir
    useRefreshTokens: true,         // token yenileme sorunlarını önler
  });

  return auth0Client;
};

export const getAuth0Client = (): Auth0Client => {
  if (!auth0Client) {
    throw new Error("Auth0 client has not been initialized. Call initAuth0() first.");
  }
  return auth0Client;
};
